"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StickyPanel = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _types = require("../../types");
var _Continue = require("../Continue");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const StickyPanel = (param)=>{
    let { continueButtonTooltip, isAnonymous, selectedStep, setCurrentStep, setIsRegistrationVisible, toPay } = param;
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { getTestIdProps } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        ...getTestIdProps(_types.TestId.StickyPanel),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.PayInfo, {
                variant: "body1",
                fontWeight: "bold",
                ...getTestIdProps(_types.TestId.ToPay),
                children: [
                    formatMessage('toPay'),
                    ": ",
                    toPay
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Continue.Continue, {
                isAnonymous: isAnonymous,
                continueButtonTooltip: continueButtonTooltip,
                selectedStep: selectedStep,
                setIsRegistrationVisible: setIsRegistrationVisible,
                setCurrentStep: setCurrentStep
            })
        ]
    });
};
exports.StickyPanel = StickyPanel;
